import { createAction } from 'redux-actions';
import { streamType as actionKey } from './constants';
export var initializeWatchSuggestions = createAction(actionKey + ".INIT");
export var fetchWatchSuggestionsSuccess = createAction(actionKey + ".FETCH.SUCCESS");
export var watchUsers = createAction(actionKey + ".WATCH.USERS");
export var unsuggestUser = createAction(actionKey + ".UNSUGGEST.USER");
//# sourceMappingURL=actions.js.map